import React, { useEffect, useRef, useState } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./CheckboxAndRadioMenu.module.css";
import PropTypes, { array } from "prop-types";
import { Dropdown } from "react-bootstrap";
import { Checkbox } from "../Checkbox/Checkbox";
import { Radio } from "../Radio/Radio";
import { Button } from "../Button/Button";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { Sleep } from "../../util/CustomFunctions";

export const CheckboxAndRadioMenu = ({
  options,
  type = "Checkbox",
  onSave,
  value,
  setValue,
  onSaveHandler,
}) => {
  const [open, setOpen] = useState(false);
  const currentTitle = useRef("");
  useEffect(() => {
    let newArray = [];
    if (options[0].title !== undefined) {
      options.map((item, index) => {
        newArray.push({
          [item.title]: [],
        });
      });
      setValue && setValue(newArray);
    }
  }, []);

  async function setArray(data) {
    await Sleep(200);
    let newData = [...value];
    if (currentTitle.current !== undefined) {
      // For Data with Title Conditions
      const findIndex = newData.findIndex((e) => {
        let keyArray = Object.keys(e);
        return keyArray[0] == currentTitle.current;
      });
      if (findIndex !== -1) {
        newData[findIndex][currentTitle.current] = data;
      }
    } else {
      // For Data without Title Conditions
      const checkIndex = newData.indexOf(data);
      if (checkIndex !== -1) {
        let newArray = newData.slice();
        newArray.splice(checkIndex, 1);
        newData = newArray;
      } else {
        if (type == "Checkbox") {
          newData = [...data];
        } else {
          newData = [data];
        }
      }
    }
    setValue(newData);
  }

  return (
    <>
      <div variant="light" show={true} className={classes.menu}>
        <div className={classes.scrollBar}>
          {options?.map((item, i) => {
            return (
              <>
                {item?.title && (
                  <p
                    className={classes.heading}
                    style={{
                      ...Fonts.h9,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    {item?.title}
                  </p>
                )}
                <ul>
                  <>
                    {item?.title == undefined ? (
                      <li
                        className={classes.menuItem}
                        onClick={() => {
                          currentTitle.current = item?.title;
                        }}
                      >
                        {type === "Checkbox" ? (
                          <Checkbox
                            label={item?.label}
                            count={item?.count}
                            value={value}
                            setValue={setArray}
                          />
                        ) : (
                          <Radio
                            label={item?.label}
                            count={item?.count}
                            value={value.length > 0 ? value[0] : ""}
                            setValue={setArray}
                          />
                        )}
                      </li>
                    ) : (
                      item?.childOptions?.map((list, index) => {
                        return (
                          <li
                            className={classes.menuItem}
                            onClick={() => {
                              currentTitle.current = item?.title;
                            }}
                          >
                            {type === "Checkbox" ? (
                              <Checkbox
                                label={list?.label}
                                count={list?.count}
                                value={value[i][item?.title]}
                                setValue={setArray}
                              />
                            ) : (
                              <Radio
                                label={list?.label}
                                count={list?.count}
                                value={
                                  value[i][item?.title].length > 0
                                    ? value[i][item?.title][0]
                                    : ""
                                }
                                setValue={setArray}
                              />
                            )}
                          </li>
                        );
                      })
                    )}
                  </>
                </ul>
              </>
            );
          })}
        </div>
        <div
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        />
        <div className={classes.btns}>
          <LinkButtonWithIcon
            text={"Clear"}
            customStyle={{
              ...Fonts.b2,
              lineHeight: "20px",
              color: Colors.neutralShadesOfNero,
            }}
          />
          <Button
            onClick={() => onSaveHandler()}
            label={"Save"}
            primary={true}
            customStyle={{ width: "64px", height: "36px" }}
          />
        </div>
      </div>

      <style jsx>{`
        .${classes.scrollBar}::-webkit-scrollbar-thumb {
          background-color: ${Colors.neutralShadesOfGainsboro};
        }
      `}</style>
    </>
  );
};

CheckboxAndRadioMenu.propTypes = {
  options: PropTypes.array,
  onSave: PropTypes.func,
  type: PropTypes.oneOf(["Checkbox", "Radio"]),
  value: PropTypes.array,
};

CheckboxAndRadioMenu.defaultProps = {
  type: "Radio",
  options: [
    {
      title: "Skill Level",
      childOptions: [
        { label: "Beginner", count: "(12)" },
        { label: "Intermediate", count: "(72)" },
        { label: "Competitive", count: "(72)" },
        { label: "Advanced", count: "(72)" },
      ],
    },
    {
      title: "Age range",
      childOptions: [
        { label: "Kids", count: "(12)" },
        { label: "Juniors", count: "(72)" },
      ],
    },
  ],
  value: [
    {
      "Skill Level": [],
    },
    {
      "Age range": [],
    },
  ],
};
